export default {
      id: "icon-mail-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-mail",
      toString: function () {
        return this.url;
      }
    }